/**
 * Shared helper functions for employee form
 */
import { format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';

// Format date to German format (DD.MM.YYYY)
export const formatDateDE = (dateString) => {
  if (!dateString) return '';
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, 'dd.MM.yyyy', { locale: de });
  } catch (e) {
    return dateString;
  }
};

// Generate random password
export const generatePassword = () => {
  const chars = 'abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789!@#$%';
  let password = '';
  for (let i = 0; i < 12; i++) {
    password += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return password;
};

// Copy text to clipboard
export const copyToClipboard = (text, toast) => {
  navigator.clipboard.writeText(text);
  toast.success('In Zwischenablage kopiert');
};

// Empty employee template
export const emptyEmployee = {
  employee_number: '',
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  mobile: '',
  date_of_birth: '',
  place_of_birth: '',
  gender: '',
  nationality: 'Deutsch',
  street: '',
  house_number: '',
  postal_code: '',
  city: '',
  country: 'Deutschland',
  position: '',
  position_list: [],
  taetigkeitsart: [],
  department: '',
  location_id: '',
  additional_location_ids: [],
  org_unit_id: '',
  employment_start: '',
  employment_end: '',
  is_temporary: false,
  employment_type: 'Vollzeit',
  working_time_model: 'weekly',
  weekly_hours: 39,
  vacation_days_per_year: 30,
  vacation_carryover: 0,
  business_phone: '',
  business_mobile: '',
  business_email: '',
  iban: '',
  bic: '',
  bank_name: '',
  qualifications: [],
  certifications: [],
  emergency_contact: { name: '', relationship: '', phone: '' },
  police_check: { issue_date: '', review_date: '', reviewed_by: '', valid: false, notes: '' },
  measles_protection: { required: false, proof_date: '', proof_type: '', verified: false, verified_by: '', notes: '' },
  trainings: [],
  custom_fields: [],
  notes: '',
  is_active: true,
  documents: [],
  contracts: [],
  reminder_enabled: null,
  reminder_threshold_minutes: null,
  pre_shift_reminder_minutes: null,
  end_shift_reminder_minutes: null,
  overtime_starting_balance: null,
  overtime_account_start: '',
};

// Empty permissions template
export const emptyPermissions = {
  role_id: null,
  scope_type: 'own',
  branch_ids: [],
  location_ids: [],
  all_branches: false,
  all_locations: false,
  permissions: {},
};
